module.exports = __webpack_public_path__ + "static/transparency_report2021@2x-4f4f13ed5eb9ef190df9429245ade2a2.png";